import React, {Component} from "react";

import "./index.scss";
import desktop_exit from "../../../../assets/icons/login-x-icon.svg";
import {sendAppLinkSms} from "../../../../redux/actions";
import {connect} from "react-redux";
import AddForm from "../../../personal_zone/address/addForm";


class AddAddress extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            popup_id: this.props.popup_id
        }
        this.animateOut = this.animateOut.bind(this);
        this.animateIn  = this.animateIn.bind(this);
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
    }

    componentWillUnmount() {
    }

    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }
    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleSubmit =() => {
        this.props.handleClose();
        this.props.action();
    }

    render(){
       let text = this.props.translations;
        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper address_popup " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <div className = "popup_content">
                        <button className = "x_close_icon"
                                onClick = { () => this.animateOut() }
                        >
                            <img src={desktop_exit} alt=''/>
                        </button>

                            <div className = "popup_content">
                                <AddForm onSubmit={this.handleSubmit} />
                            </div>
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.PopTrans,
        appDownStatus: store.data.AppDown,
        PopTrans:store.config.PopTrans,
        translations:store.config.Translations,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        sendAppLinkSms: (payload) =>dispatch(sendAppLinkSms(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(AddAddress);